import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  scanningTitle: {
    id: 'ScanningPage.scanningTitle',
    defaultMessage: 'Available Balances',
    description: 'Title for scanning page',
  },
  scanningDescription: {
    id: 'ScanningPage.scanningDescription',
    defaultMessage: `We’re scanning your available balances, which may take a while to complete.`,
    description: 'Description for scanning page',
  },
  here: {
    id: 'ScanningPage.here',
    defaultMessage: 'here',
    description: 'Link to the help center',
  },
  whereAreMyEthereumBalances: {
    id: 'ScanningPage.whereAreMyEthereumBalances',
    defaultMessage: 'Where are my Ethereum balances?',
    description:
      'Question that links to an answer for where a user can find their Ethereum balances',
  },
  whereWillMyBalancesBeDepositedTo: {
    id: 'ScanningPage.whereWillMyBalancesBeDepositedTo',
    defaultMessage: `Where will my balances be deposited to?`,
    description:
      "question that links to an answer for where a user's balances will be deposited to",
  },
  iDontHaveAWallet: {
    id: 'ScanningPage.iDontHaveAWallet',
    defaultMessage: `I don't have a wallet, where should I deposit my funds?`,
    description: `question that links to an answer for when a user does not have a wallet but still wants to withdraw their assets`,
  },
  availableBalance: {
    id: 'ScanningPage.availableBalance',
    defaultMessage: `Available balance: `,
    description: `Available Balance`,
  },
  assestsWithNoBalances: {
    id: 'ScanningPage.assestsWithNoBalances',
    defaultMessage: `Assets with no balance found`,
    description: `Assets with no balances that are found after scanning from balances`,
  },
  noFundsDetectedTooltip: {
    id: 'ScanningPage.noFundsDetectedTooltip',
    defaultMessage: `No funds detected for these assets`,
    description: `indicates that no funds were found for these assets`,
  },
  scanningAvailableBalances: {
    id: 'ScanningPage.scanningAvailableBalances',
    defaultMessage: `Scanning available balances...`,
    description: `text indicating that available balances are being scanned`,
  },
  timeRemaining: {
    id: 'ScanningPage.timeRemaining',
    defaultMessage: `{time} remaining`,
    description: `Time remaining in the scanning process`,
  },
  scanningComplete: {
    id: 'ScanningPage.scanningComplete',
    defaultMessage: `Scanning complete!`,
    description: `Time remaining in the scanning process`,
  },
  scanningCompleteMessage: {
    id: 'ScanningPage.scanningCompleteMessage',
    defaultMessage: `Balance scan complete.`,
    description: `Message displayed after scanning is complete`,
  },
  scanningError: {
    id: 'ScanningPage.scanningError',
    defaultMessage: `Something went wrong`,
    description: `Error message when scanning fails`,
  },
  percentageScanned: {
    id: 'ScanningPage.percentageScanned',
    defaultMessage: `{percentage}% of addresses scanned`,
    description: `Percentage scanned of the total during the scanning process`,
  },
  transactionsFound: {
    id: 'ScanningPage.transactionsFound',
    defaultMessage: `{number} transactions found`,
    description: `indicates that no funds were found for this asset`,
  },
});
